module.exports = __webpack_public_path__ + "media/img/scholarships/Maths Year 12-3f20a2e4b604260e2d15315d8b38280c.svg";